export default __webpack_public_path__ + "static/orangeloop-32-6691f87269c63202d98ef071fb05dfce.jpg";